import styled, { css } from 'styled-components'

export const PaymentMethod = styled.div`
  ${({ theme }) => css`
    display: flex;
    justify-content: space-between;
    flex-direction: column;

    small {
      color: ${theme.colors.neutral.low.light};
      font-size: ${theme.font.sizes.xsmall};
    }
  `}
`
